export const Tabs = ({ children }: any) => {
  return <div className="flex gap-6 p-0 text-sm w-full relative overflow-x-auto border-b">{children}</div>;
};
